import * as React from "react";
import { observer } from "mobx-react";
import { injectIntl, InjectedIntlProps, FormattedMessage } from "react-intl";
import CsvDownloader from "react-csv-downloader";
import { dataStore } from "src/models/DataStore";
import * as moment from "moment";
import {Table, Button, message} from "antd";
import "./DosageReport.less";
import { teamStore } from "src/models/TeamStore";
import {IReactionDisposer, reaction} from "mobx";
import {consoleApi, WhiteboardEnum} from "../../../apiMiddleware";
import {LoadingOutlined} from "@ant-design/icons/lib";
import SwitchRegion from "../../SwitchRegion";

export type WhiteboardDataProps = InjectedIntlProps;
export type WhiteboardDataStates = {
    activeMonth: number;
    team_duration: any[];
    isMaskLoading: boolean;
};

@observer
class DosageReportTable extends React.Component<WhiteboardDataProps, WhiteboardDataStates> {
    private readonly reactionDateDisposer: IReactionDisposer;
    public constructor(props: WhiteboardDataProps) {
        super(props);
        this.reactionDateDisposer = this.startDateReaction();
        const month = new Date().getMonth() + 1;
        this.state = {
            activeMonth: month,
            team_duration: [],
            isMaskLoading: false,
        };
    }

    private startDateReaction(): IReactionDisposer {
        return reaction(() => {
            return dataStore.dosageMonth;
        }, async date => {
            await this.handleSelectMonth(date);
        });
    }
    private handleSelectMonth = async (date: any): Promise<void> => {
        const todayTimestamp = new Date().getTime();
        if (moment(date).isSame(todayTimestamp, "month")) {
            const timestamp = new Date().getTime();
            const endDay = moment(timestamp).startOf("day").valueOf();
            const startDay = moment(timestamp).startOf("month").valueOf();
            if (endDay && startDay) {
                const resp = await consoleApi.data.getWhiteboardData(startDay, endDay, WhiteboardEnum.team);
                this.setState({team_duration: resp.data.result});
            }
        } else {
            const endDay = moment(date).endOf("month").valueOf();
            const startDay = moment(date).startOf("month").valueOf();
            if (endDay && startDay) {
                const resp = await consoleApi.data.getWhiteboardData(startDay, endDay, WhiteboardEnum.team);
                this.setState({team_duration: resp.data.result});
            }
        }
    }

    public async componentDidMount(): Promise<void> {
        try {
            this.setState({isMaskLoading: true});
            const timestamp = new Date().getTime();
            const endDay = moment(timestamp).startOf("day").valueOf();
            const startDay = moment(timestamp).startOf("month").valueOf();
            let results = [];
            if (endDay !== startDay) {
                const resp = await consoleApi.data.getWhiteboardData(startDay, endDay, WhiteboardEnum.team);
                results = resp.data.result;
            }
            this.setState({team_duration: results, isMaskLoading: false});
        } catch (err) {
            message.error(err.message);
            this.setState({isMaskLoading: false});
        }
    }

    private getTableName = (): string => {
        if (teamStore.team && teamStore.team.name) {
            return `${teamStore.team.name}-${this.state.activeMonth}月-账单`;
        } else {
            return `${this.state.activeMonth}月-账单`;
        }
    }

    private renderTable = (): React.ReactNode => {
        const { intl } = this.props;
        const {team_duration} = this.state;
        const dataSource = team_duration.map((data, index) => {
            return {
                key: `date${index}`,
                date: `${moment(data.timestamp).format("MMM Do")}`,
                writable_duration: `${data.writableDuration}`,
                readonly_duration: `${data.readonlyDuration}`,
            };
        });

        const headers = [
            { displayName: "日期", id: "date" },
            { displayName: "互动时长", id: "writable_duration" },
            { displayName: "只读时长", id: "readonly_duration" },
          ];

        const columns = [
            {
                title: intl.formatMessage({ id: "global.date" }),
                dataIndex: "date",
                width: 200,
                key: "date",
            },
            {
                title: intl.formatMessage({ id: "dash.whiteboard-writable-duration" }),
                dataIndex: "writable_duration",
                width: 200,
                key: "writable_duration",
            },
            {
                title: intl.formatMessage({ id: "dash.whiteboard-readonly-duration" }),
                dataIndex: "readonly_duration",
                width: 200,
                key: "readonly_duration",
            },
        ];
        return (
            <Table
                pagination={false}
                title={data => {
                    let writableSum = 0;
                    let readonlySum = 0;
                    data.forEach(ele => {
                        writableSum += parseInt(ele.writable_duration);
                        readonlySum += parseInt(ele.readonly_duration);
                    });
                    return (
                        <div className="measure-title">
                            <div>
                                <span style={{ marginRight: 24 }}>
                                    <FormattedMessage
                                    id="global.writable-sum"/>
                                    : {writableSum}
                                </span>
                                <span>
                                    <FormattedMessage
                                        id="global.readonly-sum"/>
                                        : {readonlySum}
                                </span>
                            </div>
                            <CsvDownloader
                                suffix={false}
                                bom={true}
                                prefix={false}
                                filename={this.getTableName()}
                                columns={headers}
                                datas={dataSource}>
                                <Button type="primary" size={"small"}>
                                    Download
                                </Button>
                            </CsvDownloader>
                        </div>
                    );
                }}
                bordered
                dataSource={dataSource}
                columns={columns} />
        );
    }
    private renderMask = (): React.ReactNode => {
        if (this.state.isMaskLoading) {
            return (
                <div className="content-box-mask">
                    <LoadingOutlined style={{fontSize: 36, color: "#3381FF"}}/>
                </div>
            );
        } else {
            return null;
        }
    }
    public render(): React.ReactNode {
        return (
            <div className="product-center-box">
                <div className="portal-room-outbox">
                    <div className="portal-room-chart">
                        <div className="portal-room-box-mid">
                            {this.renderMask()}
                            <div style={{ paddingLeft: 32 }}>
                                <SwitchRegion onChange={() => this.componentDidMount()} />
                            </div>
                            <div className="console-content-chart-body">
                                <div className="console-content-chart-box">
                                    <div className="console-content-text">
                                        <FormattedMessage
                                            id="global.duration-measurement-details"
                                        />
                                    </div>
                                    {this.renderTable()}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default injectIntl(DosageReportTable);





// WEBPACK FOOTER //
// ./src/components/portal/dataCenter/DosageReportTable.tsx